export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher50_mob_roi.bae41430.png";